/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.11",
    versionName: "0.2.0-nightly.2025.7.11",
    versionChannel: "nightly",
    buildDate: "2025-07-11T00:08:01.375Z",
    commitHash: "347a129e17ed5ee106f761241c2915f1775d7067",
};
